<template>
    <div class="timepicker-panel pa-3">
        <div class="d-flex justify-space-between align-center mb-2">
            <v-text-field
                v-model="localHours"
                ref="hoursField"
                placeholder="HH"
                label="HH"
                type="number"
                :min="0"
                :max="format === 'ampm' ? 12 : 24"
                class="pr-2 time-input-field"
                hide-details
                dense
                outlined
                @keyup.enter="$emit('apply')"
                @wheel.prevent="onWheelHours"
                @keydown.tab.stop.prevent="onTab('hours', $event)"
                @keydown.up.prevent="onKeyHour(1)"
                @keydown.down.prevent="onKeyHour(-1)"
            />
            <span class="time-separator">:</span>
            <v-text-field
                v-model="localMinutes"
                ref="minutesField"
                placeholder="MM"
                label="MM"
                type="number"
                :min="0"
                :max="60"
                class="pl-2 time-input-field"
                hide-details
                dense
                outlined
                @keyup.enter="$emit('apply')"
                @wheel.prevent="onWheelMinutes"
                @keydown.tab.stop.prevent="onTab('minutes', $event)"
                @keydown.up.prevent="onKeyMinute(1)"
                @keydown.down.prevent="onKeyMinute(-1)"

            />
            <v-btn-toggle
                v-if="format === 'ampm'"
                v-model="localAmpm"
                mandatory
                class="pl-2 ampm-toggle"
                @keyup.enter="$emit('apply')"
                @keydown.tab.stop.prevent="onTab('ampm', $event)"
            >
                <v-btn value="am" small>AM</v-btn>
                <v-btn value="pm" small>PM</v-btn>
            </v-btn-toggle>
        </div>
        <div class="d-flex justify-end align-center">
            <v-btn
                v-if="clearable && hasValue"
                class="mr-2"
                text
                small
                @click="$emit('clear')"
                @keydown.tab.stop.prevent="onTab('clear', $event)"
            >
                {{ translations.clear }}
            </v-btn>
            <v-btn
                color="primary"
                small
                @click="$emit('apply')"
                @keydown.tab.stop.prevent="onTab('apply', $event)"
            >
                {{ translations.apply }}
            </v-btn>
        </div>
    </div>
</template>

<script>
import {nextHour, nextMinute, pad} from "../../../utils/timepicker";

export default {
    name: "TimepickerPanel",
    props: {
        hours: String,
        minutes: String,
        ampm: String,
        format: String,
        clearable: Boolean,
        hasValue: Boolean
    },
    data() {
        return {
            localHours: this.hours,
            localMinutes: this.minutes,
            localAmpm: this.ampm
        };
    },
    computed: {
        translations() {
            return {
                clear: Lang.langGet('Clear'),
                apply: Lang.langGet('Apply')
            }
        }
    },
    watch: {
        hours(val) {
            this.localHours = val
        },
        minutes(val) {
            this.localMinutes = val
        },
        ampm(val) {
            this.localAmpm = val
        },
        localHours(val) {
            this.$emit("update:hours", val)
        },
        localMinutes(val) {
            this.$emit("update:minutes", val)
        },
        localAmpm(val) {
            this.$emit("update:ampm", val)
        }
    },
    methods: {
        getHoursInput() {
            const el = this.$refs.hoursField;
            return el?.$el?.querySelector("input") || null;
        },
        getMinutesInput() {
            const el = this.$refs.minutesField;
            return el?.$el?.querySelector("input") || null;
        },
        onWheelHours(e) {
            const dir = e.deltaY < 0 ? 1 : -1;
            this.localHours = nextHour(this.localHours, this.format, dir);
        },
        onWheelMinutes(e) {
            const dir = e.deltaY < 0 ? 1 : -1;
            this.localMinutes = pad(nextMinute(this.localMinutes, dir));
        },
        onTab(from, e) {
            if (e.shiftKey) {
                this.$emit('tabPrev', from);
            } else {
                this.$emit('tabNext', from);
            }
        },
        onKeyHour(direction) {
            this.localHours = nextHour(this.localHours, this.format, direction);
            this.$emit("update:hours", this.localHours.toString());
        },
        onKeyMinute(direction) {
            this.localMinutes = pad(nextMinute(this.localMinutes, direction));
            this.$emit("update:minutes", this.localMinutes.toString());
        }
    }
};
</script>

<style>
.ampm-toggle {
    flex-direction: column;
    height: 40px;
    min-width: 40px !important;
    max-width: 40px !important;
}

.ampm-toggle .v-btn {
    min-width: 20px !important;
    padding: 0 !important;
    height: 20px !important;
    min-height: 20px !important;
    flex: 1;
}

.timepicker-panel {
    background-color: #fff;
}

.time-input-field {
    max-width: 70px;
}

.time-separator {
    font-size: 18px;
    font-weight: 600;
}

.v-btn-toggle .v-btn {
    min-width: 50px;
}
</style>
